<button type="button" class="btn btn-primary" title="Filter Documents" (click)="open()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</button>

<div bsModal #advancedDocumentFilterModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="width:960px;">
        <form (ngSubmit)="applyFilter()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel" style="display:inline-block">
                        <span>Document Filter</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>System Code</label>
                                </div>
                                <input name="fileNameFilter" type="text" class="form-control" placeholder="System Code" [(ngModel)]="fileName" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="attributes.length > 0">
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[0].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedModels">
                                    <option *ngFor="let map of attributes[0].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[1].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedPoweredBys">
                                    <option *ngFor="let map of attributes[1].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="attributes.length > 0">
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[2].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedSuites">
                                    <option *ngFor="let map of attributes[2].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[4].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedLanguages">
                                    <option *ngFor="let map of attributes[4].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </div>
        </form>
    </div>
</div>
